import React, { useEffect, useState } from 'react';
import MUIDataTable from 'mui-datatables';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import customHead from 'constants/customHead';
import { getTempUserList, deleteTempUser, exportTempUserList } from '../../../../actions/admin';
import { connect } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';
import AdminContainer from 'containers/AdminContainer';
import { ThemeProvider, createTheme } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import PaginationCount from 'app/routes/components/PaginationCount';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import DatePickerForBuyerPerfomance from 'app/routes/sellerPerformance/datepicker';

const theme = createTheme({
  components: {
    MUIDataTableFilter: {
      styleOverrides: {
        reset: {
          display: "none"
        }
      }
    }
  }
});

function GuestUserList(props) {
  const navigate = useNavigate();
  const [state, setState] = useState({
    pageNo: 0,
    size: 50,
    searchedText: '',
  });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, userId: null, userName: '' });
  const [csvDialog, setCsvDialog] = useState(false);
  const [fromDate, setFromDate] = useState(moment().subtract(1, 'months').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'));
  const [verifiedOnly, setVerifiedOnly] = useState(false);

  const fetchData = (pageNo = 1, searchText = '') => {
    let data = {
      pageNo,
      size: state.size,
      searchText
    };
    props.getTempUserList({ data });
  };

  useEffect(() => {
    fetchData(1, '');
  }, []);

  const changePage = (pageNo) => {
    fetchData(pageNo + 1, state.searchedText);
    setState(prev => ({ ...prev, pageNo }));
  };

  const handleSearch = (searchText) => {
    fetchData(1, searchText);
    setState(prev => ({ ...prev, searchedText: searchText, pageNo: 0 }));
  };

  const handleDeleteConfirm = () => {
    props.deleteTempUser({
      data: { userId: deleteDialog.userId },
      onSuccess: () => {
        setDeleteDialog({ open: false, userId: null, userName: '' });
        fetchData(state.pageNo + 1, state.searchedText);
      }
    });
  };

  const handleDateChange = (date, key) => {
    if (key === 'from') {
      setFromDate(moment(date).format('YYYY-MM-DD'));
    } else {
      setToDate(moment(date).format('YYYY-MM-DD'));
    }
  };

  const openCsvDialog = () => {
    setFromDate(moment().subtract(1, 'months').format('YYYY-MM-DD'));
    setToDate(moment().format('YYYY-MM-DD'));
    setVerifiedOnly(false);
    setCsvDialog(true);
  };

  const exportCSV = () => {
    props.exportTempUserList({
      data: { fromDate, toDate, verifiedOnly },
      onSuccess: (users) => {
        if (!users || users.length === 0) {
          setCsvDialog(false);
          return;
        }

        const rows = [['Name', 'Phone', 'Email', 'Company', 'City', 'Verified', 'Status', 'Latest Session', 'Products Searched']];

        users.forEach((user) => {
          const lastSession = user.last_session;
          const sessionDate = lastSession && lastSession.login_at
            ? moment(lastSession.login_at)
            : (user.last_visited ? moment(user.last_visited) : null);

          const isActive = user.active_sessions > 0 ? 'Active' : 'Inactive';
          const products = user.searched_products && user.searched_products.length > 0
            ? user.searched_products.join(', ')
            : '-';
          rows.push([
            user.name || '-',
            user.phone || '-',
            user.email || '-',
            user.company_name || '-',
            user.city || '-',
            user.is_verified ? 'Yes' : 'No',
            isActive,
            sessionDate ? sessionDate.format('DD MMM YYYY, hh:mm A') : '-',
            products
          ]);
        });

        const csvContent = rows.map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(',')).join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const fileSuffix = verifiedOnly ? '_Verified' : '';
        a.download = `Guest_Users${fileSuffix}(${fromDate} to ${toDate}).csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        setCsvDialog(false);
      }
    });
  };

  const { tempUserList } = props;

  const totalRecords = tempUserList && tempUserList.detail && tempUserList.detail[0]
    && tempUserList.detail[0].metadata && tempUserList.detail[0].metadata.length > 0
    ? tempUserList.detail[0].metadata[0].total : 0;

  const options = {
    searchPlaceholder: 'Press Enter to Search',
    filterType: 'dropdown',
    print: false,
    download: false,
    selectableRows: false,
    selectableRowsOnClick: false,
    selectableRowsHeader: false,
    responsive: 'scroll',
    search: true,
    rowsPerPage: 50,
    page: state.pageNo,
    count: totalRecords,
    rowsPerPageOptions: [],
    viewColumns: false,
    rowHover: false,
    filter: false,
    serverSide: true,
    searchText: state.searchedText,
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page);
          break;
        case 'search':
          onkeypress = (e) => {
            if (e.key === 'Enter') {
              handleSearch(tableState.searchText);
            }
          };
          break;
        case 'onSearchClose':
          handleSearch('');
          break;
        default:
          break;
      }
    },
    customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
      return (
        <div className="p-4 d-flex justify-content-end">
          <PaginationCount page={page} rowsPerPage={rowsPerPage} count={count} />
          <Pagination
            count={Math.ceil(count / rowsPerPage)}
            page={page + 1}
            onChange={(e, page) => { changePage(page - 1) }}
            color="primary"
          />
        </div>
      );
    }
  };

  const columns = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "phone",
      label: "Phone",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "company",
      label: "Company",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "city",
      label: "City",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    // {
    //   name: "source",
    //   label: "Source",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
    //   }
    // },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "lastSession",
      label: "Latest Session",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    }
  ];

  let data = [];
  if (tempUserList && tempUserList.detail && tempUserList.detail[0] && tempUserList.detail[0].data) {
    tempUserList.detail[0].data.forEach((user) => {
      const lastSession = user.last_session;
      const isActive = user.active_sessions > 0;

      data.push({
        name: user.name || '-',
        phone: user.phone || '-',
        email: user.email || '-',
        company: user.company_name || '-',
        city: user.city || '-',
        source: user.source || 'website',
        lastSession: lastSession && lastSession.login_at
          ? moment(lastSession.login_at).format('DD MMM YYYY, hh:mm A')
          : (user.last_visited ? moment(user.last_visited).format('DD MMM YYYY, hh:mm A') : '-'),
        status: isActive
          ?  <div key={'recent'} className={` badge text-uppercase text-white bg-green`}>Active</div>
          : <div key={'recent'} className={` badge text-uppercase text-white bg-red`}>Inactive</div>,
        actions: (
          <ButtonGroup color="primary" aria-label="outlined primary button group">
            <Button className={'text-primary'} onClick={() => navigate(`/admin/guestUsers/details/${user._id}`)}>
              View
            </Button>
            <Button className={'text-danger'} onClick={() => setDeleteDialog({ open: true, userId: user._id, userName: user.name || user.phone })}>
              Delete
            </Button>
          </ButtonGroup>
        )
      });
    });
  }

  return (
    <React.Fragment>
      <AdminContainer>
        <div className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center">
          <h2 className="title mb-3 mb-sm-0">Guest Users</h2>
          <Button variant="outlined" className={'text-primary'} onClick={openCsvDialog}>
            Export CSV
          </Button>
        </div>
        {props.loading ? (
          <div className="loader-view" style={{ height: 'calc(100vh - 259px)' }}>
            <CircularProgress />
          </div>
        ) : null}

        {!props.loading && (
          <ThemeProvider theme={theme}>
            <MUIDataTable
              data={data}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        )}
      </AdminContainer>

      <Dialog open={csvDialog} onClose={() => setCsvDialog(false)} fullWidth={true} maxWidth={'sm'}>
        <form onSubmit={(e) => { e.preventDefault(); exportCSV(); }} autoComplete="off">
          <DialogTitle>
            Export Guest Users
          </DialogTitle>
          <DialogContent>
            <Row>
              <Col>
                <DatePickerForBuyerPerfomance state='from' dateValue={fromDate} handleDateChange={handleDateChange} label={"From"} />
              </Col>
              <Col>
                <DatePickerForBuyerPerfomance state="to" label={"To"} dateValue={toDate} handleDateChange={handleDateChange} />
              </Col>
            </Row>
            <Row>
              <Col>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={verifiedOnly}
                      onChange={(e) => setVerifiedOnly(e.target.checked)}
                      color="primary"
                    />
                  }
                  label="Verified users only"
                />
              </Col>
            </Row>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setCsvDialog(false)} color='secondary'>
              Cancel
            </Button>
            <Button color='primary' type='submit'>
              Download
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        open={deleteDialog.open}
        onClose={() => setDeleteDialog({ open: false, userId: null, userName: '' })}
        fullWidth={true}
        maxWidth={'sm'}
      >
        <DialogTitle>Remove Guest User?</DialogTitle>
        <DialogContent>
          <form noValidate autoComplete="off">
            <DialogContentText className='mt-3'>
              Are you sure, you want to remove this guest user?
            </DialogContentText>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog({ open: false, userId: null, userName: '' })} color='secondary'>
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color='primary'>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

const mapStateToProps = ({ admin }) => {
  const { tempUserList, loading } = admin;
  return { tempUserList, loading };
};

export default connect(mapStateToProps, { getTempUserList, deleteTempUser, exportTempUserList })(GuestUserList);
